import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Button, Accordion, IwocaLogo } from '@iwoca/orion';

import styles from './PromotionAccordion.module.css';
import { getCountry } from '../../iwIntlProvider/CountryProvider';
import MandaSVG from '../../svgComponents/mandaSVG/index';

export const PROMOTION_ACCORDION_TITLE = 'See what else iwoca can offer you';
export const MANDA_PROMOTION_TEXT =
    'We help you sell your business or acquire others with manda, powered by iwoca.';
export const MANDA_BUTTON_TEXT = 'Learn more';
export const IWOCAPAY_PROMOTION_TEXT =
    'Let your trade customers spread the cost while you get paid up front everytime with iwocaPay.';
export const IWOCAPAY_BUTTON_TEXT = 'Watch a 2 min demo';

function shouldShowPromotionAccordion(country: string): boolean {
    return country !== 'DE';
}

export function PromotionAccordion() {
    const country = getCountry();
    const showAccordion = shouldShowPromotionAccordion(country);

    useEffect(() => {
        if (showAccordion) {
            tracking.ampli.promotionalAccordionDisplayed();
        }
    }, [showAccordion]);

    if (!showAccordion) {
        return null;
    }

    const title = (
        <div className={styles['accordion-title-container']}>
            <IwocaLogo iconOnly className={styles['accordion-logo-image']} />
            <span>{PROMOTION_ACCORDION_TITLE}</span>
        </div>
    );

    return (
        <div className={styles['accordion-container']}>
            <Accordion title={title}>
                <div className={styles['accordion-content']}>
                    <div className={styles['content-box']}>
                        <MandaSVG
                            className={`${styles['content-logo-image']} ${styles['content-logo-image-manda']}`}
                        />
                        <span className={styles['content-text']}>
                            {MANDA_PROMOTION_TEXT}
                        </span>
                        <Button
                            href="https://www.iwoca.co.uk/manda"
                            target="_blank"
                            rel="noopener noreferrer"
                            size="small"
                            className={styles['content-button']}
                            onClick={() =>
                                tracking.ampli.mandaPromotionClicked()
                            }
                        >
                            {MANDA_BUTTON_TEXT}
                        </Button>
                    </div>
                    <div className={styles['content-box']}>
                        <IwocaLogo
                            iwocaPay
                            className={`${styles['content-logo-image']}`}
                        />
                        <span className={styles['content-text']}>
                            {IWOCAPAY_PROMOTION_TEXT}
                        </span>
                        <Button
                            href="https://www.iwoca.co.uk/iwocapay-seller-watch-demo?utm_source=core_biz_account_page&utm_medium=referral"
                            target="_blank"
                            rel="noopener noreferrer"
                            size="small"
                            className={styles['content-button-iwocapay']}
                            onClick={() =>
                                tracking.ampli.iwocaPayPromotionClicked()
                            }
                        >
                            {IWOCAPAY_BUTTON_TEXT}
                        </Button>
                    </div>
                </div>
            </Accordion>
        </div>
    );
}
